import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client'
import { clientToImpersonate } from '../client/impersonation'
import { memoize } from 'lodash'
import { envNoError } from 'util/env'
import { authentication } from '@ecosystem/newron-client-lib'

const customFetch: WindowOrWorkerGlobalScope['fetch'] = async (uri, options) => {
  return await fetch(uri, options)
}

export const getApolloClientWithAuthentication = memoize((token: string) => {
  const httpLink = ApolloLink.from([
    new ApolloLink(async (operation, forward) => {
      if (token) {
        const user = await authentication.getUser()
        let headers: Record<string, any> = { authorization: `Bearer ${token}` }
        if (user?.isInternalUser) {
          headers = { ...headers, ...(await clientToImpersonate()) }
        }
        const existingHeaders = operation.getContext().headers ?? {}
        operation.setContext({ headers: { ...existingHeaders, ...headers } })
      }
      return forward(operation)
    }),
    ApolloLink.split(
      (operation) => operation.getContext().name === 'ECOSYSTEM',
      new HttpLink({
        fetch: customFetch,
        uri: `${envNoError('ECOSYSTEM_BASEURL')}`,
      }),
      new HttpLink({
        fetch: customFetch,
        uri: envNoError('API_PATH'),
      })
    ),
  ])

  return new ApolloClient({
    connectToDevTools: process.env.NODE_ENV === 'development',
    cache: new InMemoryCache({
      typePolicies: {
        Answer: {
          keyFields: ['answer_id', 'answer_code'],
        },
      },
    }),
    link: httpLink,
    defaultOptions: { query: { fetchPolicy: 'no-cache' } },
  })
})
